module.exports = __webpack_public_path__ + "media/images/ecommerce/product_04-63da8df62ca5c63e2d23beecb12fc263.svg";